//Function to construct an url to a learning website.
export const modifyLink = (link: string | null) : string => {
    const originUrl = window.location.origin;
    let internalLearningHost;
    if (originUrl.includes("features.")) {
        internalLearningHost = originUrl.concat("/internallearning");
    }
    else {
        internalLearningHost = process.env.REACT_APP_LEARNING_WEBSITES;    // localhost
    }
    const newUrl = `${internalLearningHost}${link}`;
    return newUrl;
};